import { axios, Response } from '../index'

const deleteClinicTask = (clinicTaskId: string): Response<void> => {
  return axios.delete(`/v1/favorites/favorites-tasks/${clinicTaskId}`)
}

export default deleteClinicTask
